var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7279 21.7283C13.4079 21.7283 13.1039 21.6003 12.8799 21.3763L8.35191 16.8483C7.88791 16.3843 7.88791 15.6163 8.35191 15.1523C8.81591 14.6883 9.58391 14.6883 10.0479 15.1523L13.7279 18.8323L21.9519 10.6083C22.4159 10.1443 23.1839 10.1443 23.6479 10.6083C24.1119 11.0723 24.1119 11.8403 23.6479 12.3043L14.5759 21.3763C14.3519 21.6003 14.0479 21.7283 13.7279 21.7283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.2cace4083c6b04a9a2ea4ac5b591a4e8.svg";
export { ForwardRef as ReactComponent };